<template>
  <div>
    <v-row>
      <v-col sm="8" class="pa-0">
        <v-card tile class="pa-4">
          <v-form
              id="newCreationForm"
              v-model="valid"
              lazy-validation
              ref="newCreationForm"
          >
            <v-text-field
                autocomplete="off"
                v-model="newAuthor"
                :rules='authorRules'
                name="newAuthor"
                clearable
                class="rounded-0 mt-0"
                label="автор новости"
            />
            <v-text-field
                autocomplete="off"
                v-model="newTitle"
                :rules="titleRules"
                required
                name="newTitle"
                clearable
                class="rounded-0 mt-0"
                label="заголовок новости"
            />
            <v-textarea
                autocomplete="off"
                outlined
                no-resize
                rows="5"
                v-model="newContent"
                :rules="contentRules"
                required
                name="newContent"
                clearable
                class="rounded-0 mt-2"
                label="текст новости"
            />
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <v-btn tile outlined text @click="checkMethod">
        Сохранить новость
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import router from "@/router";
import {createNew, updateNew} from "@/services/newAPI";

export default {
  name: "CreationForm",
  data() {
    return {
      newTitle: "",
      newAuthor: "",
      newContent: "",

      titleRules: [
        v => !!v || 'Поле не может быть пустым',
        v => v.length < 500 || 'Максимальная длина 500',
      ],

      authorRules: [
        v => !!v || 'Поле не может быть пустым',
        v => v.length < 300 || 'Максимальная длина 300',
      ],

      contentRules: [
        v => !!v || 'Поле не может быть пустым',
        v => v.length < 3000 || 'Максимальная длина 3000',
      ],

      valid: true,
    }
  },

  props: {
    isUpdating: {
      type: Boolean,
      required: false,
      default: false
    },

    newToEdit: {
      type: Object,
      required: false,
    }
  },

  methods: {
    async send () {
      try {
        if (!this.$refs.newCreationForm.validate()) throw new Error(`can't miss out on any field`)
        await createNew( this.newTitle, this.newAuthor, this.newContent).then(data => console.log(data))
        await router.push('/news')
      } catch (e) {
        console.log(e);
      }
    },

    async updateThisNew () {
      try {
        if (!this.$refs.newCreationForm.validate()) throw new Error(`can't miss out on any field`)
        await updateNew(this.newToEdit.id ,this.newTitle, this.newAuthor, this.newContent).then(data => console.log(data))
        this.$emit('updateNew', false)
      } catch (e) {
        console.log(e);
      }
    },

    checkMethod () {
      this.isUpdating
          ? this.updateThisNew()
          : this.send()
    }

  },

  mounted() {
    if(this.isUpdating) {
      this.newTitle = this.newToEdit.title
      this.newAuthor = this.newToEdit.author
      this.newContent = this.newToEdit.content
    }
  },
}
</script>

<style scoped>

</style>